export default __webpack_public_path__ + "static/media/style.402670f2.less";